module.exports = __webpack_public_path__ + "static/media/view supplier.8723f4d5.svg";